import React, { Component } from 'react';
import { Popover } from '@lightspeed/flame/Popover';

class MenuPopover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: props.isOpen,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState(
      {
        isOpen: true,
      },
      this.props.onOpen
    );
  }

  handleClose() {
    this.setState(
      {
        isOpen: false,
      },
      this.props.onClose
    );
  }

  render() {
    const { isOpen } = this.state;
    const { target, children, ...rest } = this.props;

    return (
      <Popover
        target={target}
        {...rest}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
        isOpen={isOpen}
      >
        {typeof children === 'function'
          ? children({ handleOpen: this.handleOpen, handleClose: this.handleClose, isOpen })
          : children}
      </Popover>
    );
  }
}

MenuPopover.defaultProps = {
  isOpen: false,
  onOpen: () => {},
  onClose: () => {},
};

export default MenuPopover;
